// @flow
import { ClientConfigReducerState } from 'common/models/internal/ClientConfigReducerState';
import {
    FETCH_CLIENT_CONFIG_START,
    FETCH_CLIENT_CONFIG_COMPLETE,
    INJECT_CLIENT_CONFIG
} from 'common/constants/actionTypes';
import { ClientConfig } from 'common/models/internal/ClientConfig';
import ClientConfigService from 'common/services/ClientConfigService';

const initialState = ClientConfigReducerState.fromJS({});

export default (
    state: ClientConfigReducerState = initialState,
    action: Object
) => {
    switch (action.type) {
        case FETCH_CLIENT_CONFIG_START:
            return state.setIsLoading(true);

        case FETCH_CLIENT_CONFIG_COMPLETE:
            return state.setIsLoading(false);

        case INJECT_CLIENT_CONFIG: {
            const clientConfig = ClientConfig.fromJS(action.response);
            ClientConfigService.init(clientConfig);
            const { clientId } = action.params;
            const updatedClientConfigMap = state.clientConfigMap.set(
                clientId,
                clientConfig
            );
            return state
                .setIsLoading(false)
                .setClientConfigMap(updatedClientConfigMap);
        }

        default:
            return state;
    }
};
